import Drawer from 'components/Drawer/Drawer.component';
import HomePageLink from 'components/HomepageLink/HomepageLink.component';
import Icon from 'components/Icon/Icon.component';
import MenuTabs from 'components/MenuTabs/MenuTabs.component';
import closeIconSrc from 'images/icons/close-icon.svg';
import React from 'react';
import { useSlideInMenuControlls } from '../SlideInMenu.hooks';
import { SlideInVariantProps } from '../SlideInMenu.type';
import {
  CloseButton,
  MenuTabsWrapper,
  SlideInMenuContentWrapper,
} from '../style/ExpandedSlideInMenu.style';
import ExpandedTabContent from './ExpandedTabContent.component';

const domIdPrefix = 'expanded-menu';

const ExpandedSlideInMenu = React.forwardRef<
  HTMLDivElement,
  SlideInVariantProps
>(function ExpandedSlideInMenu(
  { navbarContent, isOpen, activeTabIndex, onClickOutside, drawerProps },
  forwardedRef,
) {
  const { closeSlideInMenu } = useSlideInMenuControlls();
  return (
    <Drawer
      {...drawerProps}
      open={isOpen}
      position="left"
      onClickOutside={onClickOutside}
      enableOverlayUI
    >
      <SlideInMenuContentWrapper
        ref={forwardedRef}
        fluidHeight
        flexDirection="column"
        flexWrap="nowrap"
        justify="flex-start"
        align="flex-start"
        padding="0 8px 0 0"
      >
        <MenuTabsWrapper>
          <HomePageLink />
          <MenuTabs
            menuTabList={navbarContent.menuTab}
            domIdPrefix={domIdPrefix}
          />
          <CloseButton onClick={closeSlideInMenu}>
            <Icon iconSize="16px" iconSrc={closeIconSrc} />
          </CloseButton>
        </MenuTabsWrapper>
        <ExpandedTabContent
          isActive={isOpen}
          activeTabIndex={activeTabIndex}
          navbarContent={navbarContent}
          domIdPrefix={domIdPrefix}
        />
      </SlideInMenuContentWrapper>
    </Drawer>
  );
});

export default ExpandedSlideInMenu;
